import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['roleType', 'featureRow', 'vipTabRow'];

  connect() {
    this.updateRowVisibility();
  }

  updateRowVisibility() {
    const selectedRole = this.roleTypeTargets.find(
      (radio) => radio.checked
    )?.value;
    const allRows = [...this.featureRowTargets, ...this.vipTabRowTargets];

    allRows.forEach((row) => {
      const limitToRoles =
        row.dataset.limitToRoles?.split(',').filter(Boolean) || [];
      if (
        limitToRoles.length > 0 &&
        row.dataset.hideWhenRoleUnavailable != null
      ) {
        row.hidden = !limitToRoles.includes(selectedRole);
      }
    });
  }

  updateRowStates() {
    this.updateRowVisibility();

    const selectedRole = this.roleTypeTargets.find(
      (radio) => radio.checked
    )?.value;
    const dashboardRoles = ['admin', 'member', 'dashboard_only'];

    const allRows = [...this.featureRowTargets, ...this.vipTabRowTargets];

    allRows.forEach((row) => {
      if (row.hidden) return;

      const limitToRoles =
        row.dataset.limitToRoles?.split(',').filter(Boolean) || [];

      const tabKey = row.dataset.key; // Get the key (feature or VIP tab)
      const optionalCheckbox = row.querySelector(
        'input[type="checkbox"][name$="[optional]"]'
      );
      const defaultCheckbox = row.querySelector(
        'input[type="checkbox"][name$="[default]"]'
      );
      const isDashboardSpecialCase =
        tabKey === 'dashboard' && dashboardRoles.includes(selectedRole);

      // Apply special dashboard tab rules
      if (isDashboardSpecialCase && optionalCheckbox && defaultCheckbox) {
        // Explicitly set states for dashboard tab for specific roles
        // Configurable per user:
        optionalCheckbox.checked = true;
        // Default enabled:
        defaultCheckbox.checked = true;
      } else {
        // For non-dashboard cases, check optional checkbox if role is in limitToRoles
        if (optionalCheckbox) {
          optionalCheckbox.checked = limitToRoles.includes(selectedRole);
        }
      }
    });

    // Update standard, non-table settings to mirror Organisation::Roles::CreateDefaultRoles
    this.updateStandardSettingsForSelectedRole(selectedRole);
  }

  // Mirrors defaults/optionals in Organisation::Roles::CreateDefaultRoles
  updateStandardSettingsForSelectedRole(selectedRole) {
    if (!selectedRole) return;

    // VIP Access Level optional when member; default admin=editor, dashboard_only=dashboard_only, else none
    const vipOptionalCheckbox = this.element.querySelector(
      'input[type="checkbox"][name="organisation_role[vip_user_role_config][optional]"]'
    );
    if (vipOptionalCheckbox)
      vipOptionalCheckbox.checked = selectedRole === 'member';
    const vipSelect = this.element.querySelector(
      'select[name="organisation_role[vip_user_role_config][default]"]'
    );
    if (vipSelect) {
      const vipDefaultValue =
        selectedRole === 'admin'
          ? 'editor'
          : selectedRole === 'dashboard_only'
          ? 'dashboard_only'
          : '';
      vipSelect.value = vipDefaultValue;
    }

    // Receive Daily Digest (checkbox) optional for admin/member, default false
    const digestOptionalCheckbox = this.element.querySelector(
      'input[type="checkbox"][name="organisation_role[receive_daily_digest_config][optional]"]'
    );
    if (digestOptionalCheckbox)
      digestOptionalCheckbox.checked = ['admin', 'member'].includes(
        selectedRole
      );
    const digestDefaultCheckbox = this.element.querySelector(
      'input[type="checkbox"][name="organisation_role[receive_daily_digest_config][default]"]'
    );
    if (digestDefaultCheckbox) digestDefaultCheckbox.checked = false;

    // RPM Recording Type (select) optional always, default rpm_recording_disabled
    const rpmOptionalCheckbox = this.element.querySelector(
      'input[type="checkbox"][name="organisation_role[rpm_recording_type_config][optional]"]'
    );
    if (rpmOptionalCheckbox) rpmOptionalCheckbox.checked = true;
    const rpmSelect = this.element.querySelector(
      'select[name="organisation_role[rpm_recording_type_config][default]"]'
    );
    if (rpmSelect) rpmSelect.value = 'rpm_recording_disabled';

    // Installer (checkbox) optional for admin/member, default false
    const installerOptionalCheckbox = this.element.querySelector(
      'input[type="checkbox"][name="organisation_role[installer_config][optional]"]'
    );
    if (installerOptionalCheckbox)
      installerOptionalCheckbox.checked = ['admin', 'member'].includes(
        selectedRole
      );
    const installerDefaultCheckbox = this.element.querySelector(
      'input[type="checkbox"][name="organisation_role[installer_config][default]"]'
    );
    if (installerDefaultCheckbox) installerDefaultCheckbox.checked = false;
  }
}
